import { render, staticRenderFns } from "./InspectionResults.vue?vue&type=template&id=1ab145dd&v-slot=props&"
import script from "./InspectionResults.vue?vue&type=script&lang=js&"
export * from "./InspectionResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports